import {
  MEETING_INTEGRATION_BY_PROVIDER,
  SERVICE_MEETING_PROVIDER,
  type ServiceMeetingProviderValue,
} from './service-integrations';

export type AvailabilityWindowInput = {
  dayOfWeek: number;
  startMinute: number;
  endMinute: number;
  timezone: string;
};

export function validateAvailabilityWindow(window: AvailabilityWindowInput): string[] {
  const errors: string[] = [];
  if (window.dayOfWeek < 0 || window.dayOfWeek > 6) {
    errors.push('Day of week must be between 0 (Sunday) and 6 (Saturday)');
  }
  if (window.startMinute < 0 || window.startMinute >= 24 * 60) {
    errors.push('Start time is invalid');
  }
  if (window.endMinute <= window.startMinute || window.endMinute > 24 * 60) {
    errors.push('End time must be after start time');
  }
  if (!window.timezone.trim()) errors.push('Timezone is required');
  return errors;
}

export function validateOneToOneOfferPublish(input: {
  title: string;
  priceCents: number;
  refundPolicyText?: string | null;
  durationMinutes: number;
  meetingProvider: ServiceMeetingProviderValue;
  manualMeetingUrl?: string | null;
  scheduleSource: 'inherit' | 'override';
  scheduleId?: string | null;
  scheduleWindowCount: number;
  calendarConnected: boolean;
}): { errors: string[]; warnings: string[] } {
  const errors: string[] = [];
  const warnings: string[] = [];

  if (!input.title.trim()) errors.push('Title is required');
  if (input.priceCents > 0 && !input.refundPolicyText?.trim()) {
    errors.push('Refund policy is required for paid offers');
  }
  if (input.durationMinutes < 15 || input.durationMinutes > 240) {
    errors.push('Duration must be between 15 and 240 minutes');
  }

  if (input.scheduleSource === 'override' && !input.scheduleId?.trim()) {
    errors.push('Select a schedule for this offer before publishing');
  }

  if (input.scheduleWindowCount <= 0) {
    errors.push('Add at least one availability window before publishing');
  }

  if (!input.calendarConnected) {
    warnings.push('Google Calendar is not connected — conflict checks will be limited');
  }

  if (input.meetingProvider === SERVICE_MEETING_PROVIDER.MANUAL) {
    if (!input.manualMeetingUrl?.trim()) {
      errors.push('Add a manual meeting URL or choose an auto meeting provider');
    }
  } else {
    const integration = MEETING_INTEGRATION_BY_PROVIDER[input.meetingProvider];
    if (integration) {
      // Connection check happens server-side; warn only here for UX copy helpers
    }
  }

  return { errors, warnings };
}

export const DEFAULT_ONE_TO_ONE_DURATION_MINUTES = 30;
export const DEFAULT_MIN_NOTICE_HOURS = 2;
export const DEFAULT_MAX_BOOKINGS_PER_DAY = 20;
export const DEFAULT_SLOT_HOLD_MINUTES = 10;
